import Vue from 'vue';
import Vuex from 'vuex';

import common from './common';
import error from './error';
import home from './home';
import hotsugg from './hotsugg';
import playlist from './playlist';
import qlist from './qlist';
import savideo from './savideo';
import search from './search';

Vue.use(Vuex);

export function createStore(config) {
  return new Vuex.Store({
    modules: {
      common: common(config),
      home,
      search,
      hotsugg,
      playlist,
      qlist,
      error,
      savideo,
    },
  });
}
